$(function(){
    // Reordera os blocos na página do produto, para o bloco de mensagens ficar logo em seguida dos produtos relacionados.
    var questionsDiv = $('.product-question-answer').parent();
    questionsDiv.insertAfter(questionsDiv.parent().children('.product-area'));
})